export default {
    // start auth
    AUTH_REQUEST: (state) => {
        state.status = 'loading'
    },
    AUTH_SUCCESS: (state, token) => {
        state.status = 'success'
        state.token = token
    },
    AUTH_ERROR: (state) => {
        state.status = 'error'
    },
    AUTH_LOGOUT: (state) => {
        state.status = ''
        state.token = ''
    },
    //end auth

    //start user
    SET_USER: (state, user) => {
        state.user = user
    },
    // end user

    //start categories
    SET_STORE_CATEGORIES: (state, categories) => {
        state.categories = categories
    },
    SET_CATEGORY_ID: (state, categoryId) => {
        state.categoryId = categoryId
    },
    //end categories

    // start store
    SET_STORE_ID: (state, storeId) => {
        state.storeId = Number(storeId)
    },
    SET_STORE: (state, store) => {
        state.store = store
    },
    UPDATE_PARENT_STORE_ID: (state, id) => {
        state.parentStoreId = id
    },
    SET_STORES: (state, stores) => {
        state.stores = stores
    },
    // end store

    // start products
    SET_PRODUCTS: (state, payload) => {
        state.products = payload
    },
    SET_ORDERS: (state, payload) => {
        state.orders = payload
    },
    // end products

    // start cart
    SET_CART: (state, cart) => {
        state.cartId = cart.id
        state.cartProducts = cart.products
    },
    EMPTY_CART: (state) => {
        state.cartProducts = []
    },
    PUSH_PRODUCT_TO_CART: (state, product) => {
        var cartItem = {
            "id": product.id,
            "name": product.name,
            "description": product.description,
            "category": product.category,
            "si_units": product.si_units,
            "si_value": product.si_value,
            "pivot": { 
                "cart_id": state.cartId,
                "product_id": product.id,
                "quantity": 1,
            }
        }
        state.cartProducts.push(cartItem)
    },
    INCREMENT_CART_ITEM_QNT: (state, cartItem) => {
        cartItem.pivot.quantity++
    },
    DECREMENT_PRODUCT_INVENTORY: (state, product) => {
        product.pivot.inventory--;
    },
    // end cart

    // start order
    SET_CURRENT_ORDER: (state, order) => {
        state.order = order
    },
    RESET_CURRENT_ORDER: (state) => {
        state.order = null
    },
    UPDATE_ORDERS: (state, order) => {
        state.orders.push(order)
    },
}